module.exports = __webpack_public_path__ + "img/NORMA-GROUP.c73682e8.png";